var prefix = 'ai-compliance';
export var setToken = function setToken(token) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  sessionStorage.setItem(prefix + '-' + (key || 'token'), token);
};
export var getToken = function getToken() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return sessionStorage.getItem(prefix + '-' + (key || 'token'));
};
export var removeToken = function removeToken() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  sessionStorage.removeItem(prefix + '-' + (key || 'token'));
};

/**
 * sessionStorage 数据管理
 */

export var setSessionStorage = function setSessionStorage(key, value) {
  sessionStorage.setItem(prefix + '-' + key, value);
};
export var getSessionStorage = function getSessionStorage(key) {
  return sessionStorage.getItem(prefix + '-' + key);
};
export var removeSessionStorage = function removeSessionStorage(key) {
  sessionStorage.removeItem(prefix + '-' + key);
};